import React from "react";
import PropTypes from "prop-types";

const PDPAccordionPanelHeader = ({title,
    children,
    isExpanded,
    className,
    expanded,
    collapsed,
    desktopCollapsible,
    smartphoneCollapsible,
    smartphoneWidth,
    handleClick,
    id,
    isFaq,
    accordionHeaderBtnClass,
    ariaLabel,
    panelIndex,
    accordionStyle = {},
}) => {
  
    const [collapsible, setCollapsible] = React.useState(false);
    React.useEffect(() => {
        let width = window.innerWidth;
        if (width <= smartphoneWidth) {
            setCollapsible(smartphoneCollapsible);
        }

        if (width > smartphoneWidth) {
            setCollapsible(desktopCollapsible);
        }
    }, [desktopCollapsible, smartphoneCollapsible, smartphoneWidth]);
    if (!collapsible && !isFaq) {
        return <div className={className}>{children}</div>;
    }
    return (
        <div
            className={className}
            id={id}
            role="presentation"
            onKeyPress={() => {}}
            onClick={() => handleClick(!isExpanded ? panelIndex : -1)}
        >
            <a
                href="javascript:void(0)"
                role="button"
                className={accordionHeaderBtnClass}
                aria-label={
                    ariaLabel ??
                    `Click to ${!isExpanded ? "Expand" : "Collapse"}: ${title}`
                }
                aria-expanded={isExpanded}
            >
                {children}
            </a>
             <span className={`right-25 lg:right-0 translate-y-m50p transform float-right ${isExpanded ? 'top-[40%]' : 'top-[50%]'} absolute headerSign`}>
                    <span style={{ display: isExpanded ? 'none' : 'inline' }}>{expanded}</span>
                    <span style={{ display: isExpanded ? 'inline' : 'none' }}>{collapsed}</span>
            </span>
        </div>
    );
};

PDPAccordionPanelHeader.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    isExpanded: PropTypes.bool.isRequired,
    accordionStyle: PropTypes.object,
    expanded: PropTypes.bool,
    collapsed: PropTypes.bool,
    desktopCollapsible: PropTypes.bool,
    smartphoneCollapsible: PropTypes.bool,
    smartphoneWidth: PropTypes.number,
    handleClick: PropTypes.func,
    id: PropTypes.string,
    isFaq: PropTypes.bool,
    className: PropTypes.string,
    accordionHeaderBtnClass: PropTypes.string,
    ariaLabel: PropTypes.string,
    panelIndex: PropTypes.number,
};

// TODO(next16): defaultProps removed in React 19 for function components.
// Convert to inline parameter defaults: const PDPAccordionPanelHeader = ({ prop = val }) =>
PDPAccordionPanelHeader.defaultProps = {
    expanded: false,
    desktopCollapsible: true,
    smartphoneCollapsible: true,
    smartphoneWidth: 768,
    handleClick: () => {},
    id: "",
    isFaq: false,
    className: "",
    accordionHeaderBtnClass: "",
    ariaLabel: "",
    panelIndex: 0,
};

export default PDPAccordionPanelHeader;

